import React from "react";
import "./tailwind.generated.css";
import MainPage from "./components/MainPage";

class App extends React.Component {
  render() {
    return <MainPage></MainPage>;
  }
}

export default App;
